<script>
import Utils from '@/services/utils.js'
const { formatLicenceId } = Utils
import UiBadge from '@/components/ui/Badge'

export default {
  name: "MonitoringWorker",
  components: {
    UiBadge,
  },
  props: {
    worker: {
      type: Object,
    },
  },
  methods: {
    formatLicenceId,
  },
  computed: {
    status: function () {
      if (this.worker && this.worker.status == 5 && !this.worker.status_reason) {
        return 'WAITING'
      }
      if (this.worker && this.worker.status == 5 && !!this.worker.status_reason) {
        return 'ERROR'
      }
      // else status: "6"
      return 'SUCCESS'
    },
  }
}
</script>

<template>
  <div class="bg-gray-100 rounded-md px-3 py-2 d-flex align-items-center">
    <div>
      <strong>{{ worker.name }}</strong>
      <div class="text-mono text-truncate text-gray-500">{{ formatLicenceId(worker.id) }}</div>
    </div>
    <div class="ml-auto">
      <UiBadge v-if="status === 'ERROR'" type="danger">{{ $t("remoteMonitoring.device_status.fail") }}</UiBadge>
      <UiBadge v-if="status === 'WAITING'" type="info">{{ $t("remoteMonitoring.device_status.waiting") }}</UiBadge>
    </div>
  </div>
</template>